module.exports = __webpack_public_path__ + "img/icon_back.abb0874d.svg";